




























 
import { Component, Vue } from 'vue-property-decorator'
import { ITuileNav } from '@/models/ui/ITuileNav'
import { getImageUrl } from '@/utils/images'


@Component({
  name:"SectionTuileAnimNav",
  components: {    
  },
  props:{    
    items:Array,
    fluid:{
      type:Boolean,
      default:true
    }
  }
})
export default class SectionTuileAnimNav extends Vue {    
  items!:Array<ITuileNav>  
  fluid!:Boolean

  carousselConfig =
  {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      swipeToSlide: true,
      responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,                    
        }
      },
      {
        breakpoint: 800,
        settings: {          
          slidesToShow: 1,          
        }
      }
    ]
  }

  get getImageUrl(){
    return getImageUrl
  }

}
